import React from 'react';
import { DOC_SELECT_MODES } from '@constants';
import { filterDocDuplicates } from '@reducers/docs';
import { StandaloneDocSelectModal } from '@containers/docSelection/StandaloneDocSelectModal';
import { logger } from '@utils/usefulFuncs';

const docSelectModes = [DOC_SELECT_MODES.allCompany, DOC_SELECT_MODES.myDocs];

export const DocSelectionModalController = ({ onInit }) => {
  const [activeNodeId, setActiveNodeId] = React.useState(null);
  const [value, setValue] = React.useState([]);
  const onChangeRef = React.useRef(() => {
    logger('onChangeRef is still not set');
  });

  const showModal = (nodeId, value, onChange) => {
    setActiveNodeId(nodeId);
    setValue(value || []);
    onChangeRef.current = onChange;
  };

  const hideModal = () => {
    setActiveNodeId(null);
  };

  React.useEffect(() => {
    onInit({ showModal, hideModal });
  }, []);

  if (!activeNodeId) {
    return null;
  }

  const onAddDocument = (docOrDocs) => {
    const docs = Array.isArray(docOrDocs) ? docOrDocs : [docOrDocs];
    const nextValue = filterDocDuplicates([...value, ...docs]);
    onChangeRef.current(nextValue);
    setValue(nextValue);
  };
  const onRemoveDocument = (docOrDocs) => {
    const docs = Array.isArray(docOrDocs) ? docOrDocs : [docOrDocs];
    const docIds = docs.map((d) => d.id);
    const nextValue = value.filter((selectedDoc) => !docIds.includes(selectedDoc.id));
    onChangeRef.current(nextValue);
    setValue(nextValue);
  };
  return (
    <StandaloneDocSelectModal
      docMode={docSelectModes[0]}
      defaultActiveMode={docSelectModes[0]}
      docSelectModes={docSelectModes}
      selectedDocs={value}
      handleAddDocument={onAddDocument}
      handleRemoveDocument={onRemoveDocument}
      onDismiss={hideModal}
    />
  );
};
